import { z } from "zod";

export const CommissionAttributeSchema = z.object({
  id: z.number(),
  /** @deprecated use `id` instead */
  commissionAttributeId: z.number(),
  type: z.number(),
  name: z.string(),
  isActive: z.boolean(),
  documentSeriesDefinition: z.string(),
  displayPriority: z.number(),
  option: z.string(),
  isForPosition: z.boolean(),
  additionalOptions: z.string(),
  chatbox: z.boolean(),
  registerEventOnchange: z.boolean(),
  ordering: z.number(),
  tooltip: z.string(),
  uuid: z.string(),
  parent: z.any(),
  attributeMultis: z.any(),
});

export const PartialCommissionAttributeSchema =
  CommissionAttributeSchema.deepPartial();

export type PartialCommissionAttribute = z.infer<
  typeof PartialCommissionAttributeSchema
>;
export type CommissionAttribute = z.infer<typeof CommissionAttributeSchema>;
